import { createSlice } from "@reduxjs/toolkit";
import { FilterStateGenerateTerm } from "./types";

const INITIAL_STATE: FilterStateGenerateTerm = {
  filters: {
    search: "",
    store_code: "",
    status: "",
    start_date: "",
    end_date: "",
    orderBy: {},
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

const generateTermFilterSlice = createSlice({
  name: "generateTermFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setGenerateTermFilter(state, action) {
      const { key, value } = action.payload;

      if (key === "meta") {
        state.filters.meta = {
          ...state.filters.meta,
          ...value,
        };
      } else {
        state.filters[key] = value;
      }
    },
    clearGenerateTermFilters(state) {
      state.filters = { ...INITIAL_STATE.filters };
    },
  },
});

export const { setGenerateTermFilter, clearGenerateTermFilters } =
  generateTermFilterSlice.actions;

export default generateTermFilterSlice.reducer;